<template>
  <div class="col-12 col-md-4 col-lg-4">
    <div class="card mb-2 w-100 pointer post-conte">
      <img :src="portada" class="mw-100"
           alt="SUSTITUIR POR LOS NOMBRES DE LOS VEHICULOS PARA EL SEO">
      <div class="card-body">
        <h5 class="card-title text-left font-weight-bold mb-0 mt-4">{{ titulo }}</h5>
        <small>{{ fecha }}</small>
        <div class="d-flex mt-2 mb-2">
          <p class="mb-8 pl-2" :style="{ fontSize: '14px'}">
              <strong> Autor{{ autor }}</strong>
          </p>
        </div>
        <p class="card-text text-justify mb-64" style="font-size: 16px;">{{ contenido }}</p>
        <a :href="'/article/' + id" class="btn btn-outline-primary d-block mx-auto" style="border-radius: 0px;position: absolute;bottom: 25px;width: 88%;">Ver artículo</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogEntrance',
  props: {
    portada: String,
    titulo: String,
    id: Number,
    fecha: String,
    autor: String,
    contenido: String
  }
}
</script>

<style scoped>

</style>
